import type {
  MediaImageFragment,
  ParagraphHeading,
  ParagraphHeroItem,
  ParagraphIconSectionItem,
  ParagraphRoomOverviewItem,
} from '~/api/graphql/generated'

type WithTypename = {
  __typename?: string
}

const hasTypename = (entity: unknown): entity is WithTypename => {
  return typeof entity === 'object' && entity !== null && '__typename' in entity
}

export const createTypenameGuard = <TEntity extends WithTypename>(typename: Extract<TEntity['__typename'], string>) => {
  return (entity: unknown): entity is TEntity => {
    return hasTypename(entity) && entity.__typename === typename
  }
}

export const isParagraphHeroItem = createTypenameGuard<ParagraphHeroItem>('ParagraphHeroItem')
export const isMediaImage = createTypenameGuard<MediaImageFragment>('MediaImage')
export const isParagraphHeading = createTypenameGuard<ParagraphHeading>('ParagraphHeading')
export const isParagraphRoomOverviewItem = createTypenameGuard<ParagraphRoomOverviewItem>('ParagraphRoomOverviewItem')
export const isParagraphIconSectionItem = createTypenameGuard<ParagraphIconSectionItem>('ParagraphIconSectionItem')
